import { Component, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Authenticate } from "../../models/authenticate";

import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
  standalone: true,
  selector: 'app-processlink',
  templateUrl: './processlink.html',
  styleUrls: ['./processlink.css'],
  imports: [CommonModule]
})
export class ProcessLink implements OnInit {

  authenticate!: Authenticate;
  uniqueid?: string;
  pin?: string;
  isLoading = true;
  message = '';
  showDivRouteToHomePage: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private storage: LocalStorageService,
  ) { }

  ngOnInit() {
    
    const uniqueId = this.route.snapshot.queryParamMap.get('uniqueid');
    const pin = this.route.snapshot.queryParamMap.get('pin');
   

    //console.log('uniqueId:', uniqueId);
    //console.log('pin:', pin);

    if (uniqueId && pin) {
      this.Process(uniqueId, pin);
    } else {
      this.isLoading = false;
      this.message = 'This credentialed link is missing a unique ID or PIN.';
    }
  }

  Process(uniqueid: any, pin: any) {
    const au = {
      uniqueId: uniqueid,
      pin: pin
    };

    this.storage.store('authenticatedUser', au);
    this.isLoading = false;
    this.router.navigate(['/file']);
  }
}
